﻿define([
    'pubsub',
    'generalUtilities',
    'agentsSearchUtilities',
    'agentsSearchControl',
    'userSearchGridControl',
    'agentsDeepLinkControl',
    'loadMoreControl',
    'userSearchResultsSummaryControl',
    'userSearchScrollControl',
    'navigationControl',
    'mixpanelControl',
    'languageControl',
    'connectionControl',
    'notificationsDrawerControl',
    'locationConfirmControl',
    'accordionControl'
], function agentsInitialiser(pubsub, generalUtilities, agentsSearchUtilities) {
    'use strict';

    var agentListGuid;

    agentListGuid = generalUtilities.uuid();

    pubsub.publish('uiWantsAgentsSearchControlInit', {
        guid: agentListGuid
    });

    pubsub.publish('uiWantsUserSearchGridControlInit', {
        guid: agentListGuid
    });

    pubsub.publish('uiAction.UserSearchResultSummaryControlInit', {
        guid: agentListGuid
    });

    pubsub.publish('uiWantsAgentsDeepLinkControlInit', {
        guid: agentListGuid
    });

    pubsub.publish('uiWantsLoadMoreInit', {
        guid: agentListGuid,
        watch: 'dataUserSearchBrowse',
        mpDataFrom: 'user-discovery',
        rowItemRemainder: agentsSearchUtilities.private.rowItemRemainder
    });
});
